import React from 'react';
import { TextArea } from 'semantic-ui-react';
import FormbuilderFieldWrapper from '../../../../formBuilderAnswersComponents/formbuilderFieldWrapper';

interface TextAreaFieldProps {
  label?: string;
  value?: number | string;
  update: (value: string) => void;
  fieldName: string;
  validation?: unknown;
  subtext?: string;
  systemOnly?: boolean;
}

const TextAreaField = ({
  label,
  value,
  update,
  fieldName,
  validation,
  subtext,
  systemOnly
}: TextAreaFieldProps) => (
  <FormbuilderFieldWrapper
    inputSub={subtext}
    label={label}
    systemOnly={systemOnly}
    validation={validation}
    value={value}
  >
    <TextArea
      placeholder={value}
      value={value}
      onChange={(event) => update(event.target.value)}
      id={`${fieldName}Id`}
    />
  </FormbuilderFieldWrapper>
);

export default TextAreaField;
